import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import Label from '../../components/shared/Label';
import { HeaderWrapper } from './styles';

const CycleHeader = ({ isMobile, isCustomRace }) => (
  <HeaderWrapper isMobile={isMobile} isCustomRace={isCustomRace}>
    <Row style={{
      width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center',
    }}
    >
      <Col lg={1} md={2} sm={2} style={{ paddingLeft: '10px', paddingRight: '5px' }}>
        <Label
          label="Data"
          weight="bold"
          size={0.9}
        />
      </Col>
      {!isMobile &&
        <Col lg={1.5} md={isCustomRace ? 2 : 1.5} sm={isCustomRace ? 2 : 1.5} style={{ paddingLeft: '5px', paddingRight: '5px' }}>
          <Label
            label="Tappa"
            weight="bold"
            size={0.9}
          />
        </Col>
      }
      <Col
        lg={isCustomRace ? 3 : 4}
        md={isCustomRace ? 4.5 : 5}
        sm={isCustomRace ? 4.5 : 5}
        style={{
          paddingLeft: '5px',
          paddingRight: '5px',
          display: 'flex',
          justifyContent: 'flex-start',
          textAlign: 'left',
          overflow: 'visible',
        }}
      >
        <Label
          label="Nome"
          weight="bold"
          size={0.9}
        />
      </Col>
      {!isMobile &&
      <Col lg={1} md={1} sm={1} style={{ paddingLeft: '5px', paddingRight: '5px' }}>
        <Label
          label="Dist."
          weight="bold"
          size={0.9}
        />
      </Col>
      }
      <Col lg={isCustomRace ? 2.5 : 4} md={isCustomRace ? 4.5 : 4} sm={isCustomRace ? 4.5 : 4} style={{ paddingLeft: '5px', paddingRight: '10px' }}>
        <Label
          label="Vincitore"
          weight="bold"
          size={0.9}
        />
      </Col>
      {isCustomRace && !isMobile &&
      <Col lg={2.5} md={2.5} sm={2.5} style={{ paddingLeft: '5px', paddingRight: '10px' }}>
        <Label
          label="Maglia Rosa"
          weight="bold"
          size={0.9}
        />
      </Col>}
      <Col lg={0.5} md={1} sm={1} style={{ paddingLeft: '5px', paddingRight: '10px' }} />
    </Row>
  </HeaderWrapper>
);

CycleHeader.propTypes = {
  isMobile: PropTypes.bool,
  isCustomRace: PropTypes.bool,
};

export default CycleHeader;



// WEBPACK FOOTER //
// ./src/components/CycleHeader/index.js